import fontawesome from '@fortawesome/fontawesome';
import {
  faTachometer,
  faFlask,
  faUsers,
  faChartBar,
  faShieldCheck,
  faHdd,
  faFileAlt,
  faDownload,
  faPlus,
  faBackward,
  faPrint,
  faCircle as faRegularCircle,
} from '@fortawesome/fontawesome-pro-regular';

import {
  faCog,
  faCopy,
  faEllipsisVAlt,
} from '@fortawesome/fontawesome-pro-light';

import {
  faCircle,
} from '@fortawesome/fontawesome-pro-solid';

fontawesome.library.add(
  faTachometer,
  faFlask,
  faUsers,
  faChartBar,
  faShieldCheck,
  faCog,
  faCopy,
  faEllipsisVAlt,
  faHdd,
  faFileAlt,
  faDownload,
  faPlus,
  faBackward,
  faPrint,
  faCircle,
  faRegularCircle,
);



// WEBPACK FOOTER //
// ./src/core/font-awesome.js